import { Brigade, BrigadeForm } from "../types/brigade";

export function getBrigadeFormValues(brigade: Brigade): BrigadeForm {
  return {
    name: brigade.name,
    image: brigade.image,
  };
}
